import { Component, OnInit } from '@angular/core';
import * as CanvasJS from '../../canvasjs.min';
import { SampleService } from 'src/app/core/http/sample.service';
import { map } from 'rxjs/operators';
import { ModalService } from 'src/app/shared/services/modal.service';
import { AddQcModalComponent } from 'src/app/shared/components/add-qc-modal/add-qc-modal.component';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-graph-chart',
  templateUrl: './graph-chart.component.html',
  styleUrls: ['./graph-chart.component.scss'],
})
export class GraphChartComponent implements OnInit {
  uclChart: CanvasJS.Chart;
  lclChart: CanvasJS.Chart;
  qcData;
  qcValueData;
  data;
  isLoading = true;
  Errors = null;
  qcId;
  searchQuery: string = '';
  mode = 'table';
  chartName;
  chartStartDate;
  chartStopDate;
  graphType = 'Full';
  fullVisi = true;
  highVisi = false;
  lowVisi = false;
  startDate: any;
  endDate: any;
  start: any;
  endd: any;

  constructor(private sample: SampleService, private modal: ModalService) {}

  ngOnInit(): void {
    this.getQc();
    this.startDate = null;
    this.endDate = null;
  }

  getQc() {
    console.log('calleddddddddd');
    this.sample.getQc().subscribe(
      (resSuccess) => {
        this.qcData = resSuccess;
        console.log(resSuccess, 'qcccccccccc');
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  searchName(name: string) {
    if (name.trim() === '') {
      // If the search input is empty, reset the data
      this.sample.getQc().subscribe(
        (resSuccess) => {
          this.qcData = resSuccess;
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    } else {
      // Filter the data based on the name
      this.sample
        .getQc()
        .pipe(
          map((data: any) =>
            data.filter((item: any) =>
              item.Name.toLowerCase().includes(name.toLowerCase())
            )
          )
        )
        .subscribe(
          (filteredData) => {
            this.qcData = filteredData;
          },
          (resErr) => {
            this.Errors = resErr;
          }
        );
    }
  }

  back() {
    this.mode = 'table';
  }

  full() {
    this.graphType = 'Full';
    this.fullVisi = true;
    this.lowVisi = false;
    this.highVisi = false;
  }
  high() {
    this.graphType = 'High';
    this.fullVisi = false;
    this.lowVisi = false;
    this.highVisi = true;
  }
  low() {
    this.graphType = 'Low';
    this.fullVisi = false;
    this.lowVisi = true;
    this.highVisi = false;
  }

  startDateChange(event: any) {
    this.startDate = moment(event.target.value).format('YYYY-MM-DDTHH:mm:ss');
    this.start = event.target.value;
  }
  endDateChange(event: any) {
    this.endDate = moment(event.target.value).format('YYYY-MM-DDTHH:mm:ss');
    this.endd = event.target.value;
  }

  filterDataByDateRange(data, startDate, endDate) {
    if (!startDate || !endDate) {
      return data;
    }

    return data.filter((item) => {
      const itemDate = moment(item.Timestamp);
      return itemDate.isBetween(startDate, endDate, null, '[]');
    });
  }

  updateDateRange(): void {
    this.qcValueData = this.filterDataByDateRange(
      this.data,
      this.startDate,
      this.endDate
    );

    this.createChartWithDynamicData(this.qcValueData);
    console.log(this.qcValueData);
  }

  openModal() {
    this.modal.openModal(AddQcModalComponent, 'modal');
  }

  getQcValue(item) {
    this.mode = 'graph';
    console.log('Valuessss');
    this.sample.getQcValues(item.Id).subscribe(
      (resSuccess) => {
        this.qcValueData = resSuccess;
        this.data = resSuccess;
        this.chartName = item.Name;
        this.chartStartDate = moment(item?.StartDate).format(
          'MMM D, YYYY, h:mm:ss A'
        );
        if (item?.StopDate === null) {
          this.chartStopDate = 'Till Date';
        } else {
          this.chartStopDate = moment(item?.StopDate).format(
            'MMM D, YYYY, h:mm:ss A'
          );
        }

        console.log(resSuccess, 'Valuesssssssss');
        this.createChartWithDynamicData(this.qcValueData);
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  createChartWithDynamicData(data): void {
    const uclData = [];
    const lclData = [];
    const clData = [];

    // Transform the received data into the format expected by CanvasJS
    let transformedData = data
      .map((item) => ({
        x: new Date(item.Timestamp),
        y: item.ParamValue,
        z: item.Id,
      }))
      .sort((a, b) => a.x.getTime() - b.x.getTime());

    let chart = new CanvasJS.Chart('chartContainer', {
      title: {
        text: ' LJ Chart',
      },
      axisY: {
        gridThickness: 0,
      },
      data: [
        {
          type: 'line',
          xValueType: 'dateTime',
          dataPoints: transformedData, // Use the transformed data here
          toolTipContent: '{x}, {y}, Id: {z}',
        },
      ],
    });

    this.createLJChart(chart);
    chart.render();

    const average = this.calculateAverage(transformedData);
    const standardDeviation = this.calculateStandardDeviation(
      transformedData,
      average
    );

    transformedData.forEach((item) => {
      if (item.y > average) {
        uclData.push({ x: item.x, y: item.y, z: item.z });
      } else if (item.y < average) {
        lclData.push({ x: item.x, y: item.y, z: item.z });
      } else {
        clData.push({ x: item.x, y: item.y, z: item.z });
      }
    });

    this.renderChart('uclChartContainer', 'High LJ Chart', uclData);
    this.renderChart('lclChartContainer', 'Low LJ Chart', lclData);
  }

  calculateAverage(data): number {
    const sum = data.reduce((acc, curr) => acc + curr.y, 0);
    return sum / data.length;
  }

  calculateStandardDeviation(data, average): number {
    const sumOfSquaredDifferences = data.reduce(
      (acc, curr) => acc + Math.pow(curr.y - average, 2),
      0
    );
    return Math.sqrt(sumOfSquaredDifferences / data.length);
  }

  renderChart(containerId: string, title: string, data): void {
    const chart = new CanvasJS.Chart(containerId, {
      title: {
        text: title,
      },
      axisY: {
        gridThickness: 0,
      },
      data: [
        {
          type: 'line',
          xValueType: 'dateTime',
          dataPoints: data,
          toolTipContent: '{x}, {y}, Id: {z}',
        },
      ],
    });

    chart.render();
  }
  createLJChart(chart: any): void {
    let average = 0,
      standardDeviation = 0;
    let dataPoint = chart.options.data[0].dataPoints;

    // Calculate Average/Median
    dataPoint.forEach((dp: { y: number }) => {
      average += dp.y;
    });
    average /= dataPoint.length;

    // Calculate Standard Deviation
    dataPoint.forEach((dp: { y: number }) => {
      standardDeviation += Math.pow(dp.y - average, 2);
    });
    standardDeviation = Math.sqrt(standardDeviation / (dataPoint.length - 1));

    chart.options.axisY = chart.options.axisY || {}; // Ensure axisY is initialized
    chart.options.axisY.stripLines = chart.options.axisY.stripLines || []; // Ensure stripLines array is initialized

    let stripLines = chart.options.axisY.stripLines;
    let valueMin,
      valueMax,
      labelArray = [
        ['CL', 'CL'],
        ['-1SD', '+1SD'],
        ['-2SD', '+2SD'],
        ['LCL', 'UCL'],
      ];

    for (let i = 0; i <= 3; i++) {
      valueMin = CanvasJS.formatNumber(average - standardDeviation * i, '0.00');
      valueMax = CanvasJS.formatNumber(average + standardDeviation * i, '0.00');

      if (i > 0) {
        stripLines.push({
          value: parseFloat(valueMin),
          label: valueMin,
          labelAlign: 'far',
          lineDashType: 'dash',
        });
        stripLines.push({
          value: parseFloat(valueMin),
          labelAlign: 'near',
          label: labelArray[i][0],
          lineDashType: 'dash',
        });
      }

      stripLines.push({
        value: parseFloat(valueMax),
        label: valueMax,
        labelAlign: 'far',
        lineDashType: i > 0 ? 'dash' : 'line',
        color: i == 0 ? 'black' : 'orange',
      });
      stripLines.push({
        value: parseFloat(valueMax),
        labelAlign: 'near',
        label: labelArray[i][1],
        lineDashType: i > 0 ? 'dash' : 'line',
        color: i == 0 ? 'black' : 'orange',
      });
    }

    chart.options.axisY.minimum = parseFloat(valueMin) - 1;

    // Highlight datapoints beyond 2SD
    dataPoint.forEach((dp: any) => {
      if (
        dp.y >
          parseFloat(
            CanvasJS.formatNumber(average + standardDeviation * 2, '0.00')
          ) ||
        dp.y <
          parseFloat(
            CanvasJS.formatNumber(average - standardDeviation * 2, '0.00')
          )
      ) {
        dp.markerSize = 10;
        dp.markerColor = 'red';
      }
    });
  }
}
